// Environmental Initiatives page English translations

export default {
  pageTitle: "Environmental Initiatives",
  breadcrumbHome: "Home",
  breadcrumbSustainability: "Sustainability",
  breadcrumbCurrent: "Environmental Initiatives",
  title: "Environmental Initiatives",
  sustainability: "Sustainability",
  conceptOfSustainability: "Concept of Sustainability",
  environmentalInitiatives: "Environmental Initiatives",
  occupationalHealthSafety: "Occupational Health & Safety",
  socialContributionInitiatives: "Social Contribution Initiatives",
  
  // Environmental Initiatives Details Section
  environmentalInitiativesTitle: "Environmental Initiatives at P.T. Eagle Industry Indonesia",
  environmentalInitiativesDesc1: "P.T. Eagle Industry Indonesia operates in the manufacturing of seals for automotive components with main processes of Casting and O-ring that function as lubricant retainers with the external environment such as water, mud, or dust in the under carrier area of construction machinery, heavy equipment, or agricultural machines.",
  environmentalInitiativesDesc2: "With precision technology and high quality, our products help improve machine reliability while supporting environmental impact reduction, as they play a role in preventing pollution from oil or fluid leakage to the ground.",
  
  // Environmental Management System Section
  environmentalManagementSystemTitle: "Environmental Management System",
  environmentalManagementSystemDesc: "As part of the EKK Group, P.T. Eagle Industry Indonesia consistently conducts environmental preservation activities. The company has been certified ISO 14001:2015 as evidence of implementing an internationally standardized environmental management system.",
  
  // Environmental Policy Section
  environmentalPolicyTitle: "Environmental Policy",
  environmentalPolicyDesc: "P.T.  Eagle Industry Indonesia recognizes and cares for the environment. Committed to protecting the environment and preventing pollution as well as global warming, by saving energy and using resources, as well as utilizing renewable energy.",
  
  // Environmental Activities Section
  environmentalActivitiesTitle: "Environmental Activities",
  solarPanelGenerationTitle: "Solar Panel Generation",
  solarPanelGenerationDesc: "P.T.  Eagle Industry Indonesia began utilizing solar power generation since early 2025, as part of efforts to reduce CO2 emissions.",
  
  // Environmental Awards and Certifications Section
  environmentalAwardsTitle: "Environmental Awards and Certifications",
  environmentalAwardsDesc: "P.T.  Eagle Industry Indonesia implements ISO 14001:2015 Environmental Management System. Then received the PROPER Blue rating from the Ministry of Environment and Forestry of the Republic of Indonesia, as recognition for compliance with environmental regulations in Indonesia.",
  
  // Environmental & Safety Certifications Section
  environmentalSafetyCertificationsTitle: "Environmental & Safety Certifications",
  environmentalSafetyCertificationsDesc: "Our commitment to environmental management and occupational health & safety standards",
  
  // Certification Table
  certificationTable: {
    certification: "Certification",
    standard: "Standard",
    description: "Description",
    qualityManagementSystem: "Quality Management System",
    qualityManagementSystemDesc: "International standard for quality management systems that demonstrates our ability to consistently provide products and services that meet customer and regulatory requirements while enhancing customer satisfaction",
    environmentalManagementSystem: "Environmental Management System",
    environmentalManagementSystemDesc: "International standard for environmental management systems that helps organizations minimize their environmental impact while complying with regulations",
    occupationalHealthSafety: "Occupational Health & Safety Management",
    occupationalHealthSafetyDesc: "International standard for occupational health and safety management systems that provides a framework for improving employee safety, reducing workplace risks, and creating better working conditions",
    environmentalCompliance: "Environmental Compliance",
    environmentalComplianceDesc: "Recognition from the Ministry of Environment and Forestry of the Republic of Indonesia for compliance with environmental regulations in industrial operations",
    noteText: "Note: These certifications demonstrate our commitment to environmental preservation, occupational health & safety, and sustainable practices."
  },
  
  // Certification Evidence Section
  certificationEvidenceTitle: "Certification Evidence",
  certificationEvidenceDesc: "View our environmental certifications and compliance documents",
  issuer: "Issuer",
  issueDate: "Issue Date",
  expiryDate: "Expiry Date",
  viewCertificate: "View Certificate",
  
  // Related Topics Section
  relatedTopicsTitle: "Related Sustainability Topics",
  relatedTopicsDesc: "Explore more about our sustainability initiatives",
  conceptOfSustainabilityCard: "Concept of Sustainability",
  socialContributionInitiativesCard: "Social Contribution Initiatives",
  occupationalHealthSafetyCard: "Occupational Health & Safety"
};